import '@styles/pages/seller-page-space.scss';

import { initCarousel } from '@organisms/carousel';
import { initGallery } from '@organisms/gallery';
import { initMapLocation } from '@pages/seller-page-space/map-location';
import { initVirtualvisit } from './seller-page-space/virtual-visit';
import { initSpaceDetails } from './seller-page-space/space-details';

initMapLocation();
initCarousel();
initSpaceDetails();
initVirtualvisit();
initGallery();
